<div class="position-relative overflow-hidden h-100 d-flex">
    <div class="flex-grow-1 overflow-hidden px-sm-4" [class.pt-4]="!embedded">
        <dx-data-grid
            [style]="(`height: calc(100vh - ${offset}px)`)"
            class="grid theme-dependent"
            noDataText=""
            [dataSource]="dataSource"
            [allowColumnResizing]="true"
            [allowColumnReordering]="true"
            [focusedRowEnabled]="true"
            [autoNavigateToFocusedRow]="false"
            [showBorders]="true"
            [remoteOperations]="true"
            [columnAutoWidth]="true"
            [wordWrapEnabled]="true"
            [customizeColumns]="customizeColumns"
            [stateStoring]="{
                enabled: true,
                type: 'localStorage',
                storageKey: `change-requests-${employeeId ? 'employee-' : ''}grid-state`,
                savingTimeout: 0
            }"
            (onExporting)="onExporting($event)"
            keyExpr="id"
            (onRowDblClick)="onRowDblClick($event)"
            width="100%"
        >
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager
                [visible]="true"
                [displayMode]="'full'"
                [showPageSizeSelector]="true"
                [showInfo]="true"
                [showNavigationButtons]="true"
            >
            </dxo-pager>

            <dxo-scrolling [scrollByContent]="true"></dxo-scrolling>
            <dxo-load-panel [showPane]="false"></dxo-load-panel>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
            <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
            <dxo-export [enabled]="true" [formats]="['xlsx']"></dxo-export>
            <dxo-toolbar>
                <dxi-item location="before">
                    <div class="grid-header">Change Requests</div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    widget="dxButton"
                    [options]="{ text: 'Filters', icon: 'fa-sharp fa-thin fa-filter', onClick: toggleFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    widget="dxButton"
                    showText="inMenu"
                    [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    showText="inMenu"
                    widget="dxButton"
                    [options]="{
                    text: 'Reset',
                    icon: 'restore',
                    onClick: resetGrid,
                    stylingMode: 'text'
                }"
                ></dxi-item>
                <!-- Separator -->
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item name="exportButton"></dxi-item>
                <dxi-item name="columnChooserButton" locateInMenu="auto"></dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="never"
                    [visible]="auth.checkPermission(PermissionType.InformationChangeRequestsStatusChange, AccessType.Edit)"
                >
                    <dx-button
                        text="New Request"
                        icon="plus"
                        type="default"
                        stylingMode="contained"
                        (onClick)="addRow()"
                    ></dx-button>
                </dxi-item>
            </dxo-toolbar>

            <dxi-column [dataField]="gridFieldName('number')" caption="ID" [minWidth]="100" cellTemplate="id"></dxi-column>

            @if (!employeeId) {
                <dxi-column [dataField]="'employee.name'" caption="Employee" cellTemplate="employee" [minWidth]="250"
                            [calculateFilterExpression]="nameOrEmailFilter"></dxi-column>
            }

            <dxi-column [dataField]="gridFieldName('typeOfChange')" caption="Type" [minWidth]="150" cellTemplate="type"
                        [lookup]="{ dataSource: typeOptions, valueExpr: 'value', displayExpr: 'text' }"
                        [headerFilter]="{ dataSource: typeOptions }"
            ></dxi-column>
            <dxi-column [dataField]="gridFieldName('status')" caption="Status" [minWidth]="150" cellTemplate="status"
                        [lookup]="{ dataSource: statusOptions, valueExpr: 'value', displayExpr: 'text' }"
                        [headerFilter]="{ dataSource: statusOptions }"
            ></dxi-column>
            <dxi-column [dataField]="gridFieldName('submittedDate')" caption="Submitted Date" [minWidth]="150"
                dataType="date" [sortIndex]="0" [sortOrder]="'desc'"
            ></dxi-column>
            <dxi-column [dataField]="gridFieldName('finalizedDate')" caption="Finalized Date" [minWidth]="150"
                        dataType="date"></dxi-column>
            <dxi-column type="buttons" caption="Actions">
                <dxi-button text="edit" icon="edit" hint="edit" [onClick]="onEdit" [visible]="isEditVisible"></dxi-button>
                <dxi-button text="view" icon="eyeopen" hint="view" [onClick]="onView" [visible]="isViewVisible"></dxi-button>
            </dxi-column>

            <div *dxTemplate="let cellInfo of 'type'">
                {{ cellInfo.value | capitalCase }}
            </div>
            <div *dxTemplate="let cellInfo of 'status'">
                <span class="badge" [ngClass]="getBadgeClass(getCellData(cellInfo).status)">
                    {{ cellInfo.value | capitalCase }}
                </span>
            </div>
            <div *dxTemplate="let cellInfo of 'employee'">
                <user-avatar-email
                    [email]="getCellData(cellInfo).employee.email"
                    [name]="getCellData(cellInfo).employee.name"
                    [avatarUrl]="getCellData(cellInfo).employee.avatarUrl"
                    [employeeId]="getCellData(cellInfo).employee.id"
                ></user-avatar-email>
            </div>
            <div *dxTemplate="let cellInfo of 'id'">
                <div class="text-primary fw-semibold">
                    {{ getCellData(cellInfo).number }}
                </div>
            </div>
        </dx-data-grid>
    </div>

    <filter-panel
        [(isOpened)]="isFilterPanelOpened"
        (onSearch)="applyFilters()"
        (onClear)="clearFilters()"
        (pinnedChange)="onPinnedChange()"
    >
        <dx-form [formData]="filterModel">
            <dxi-item
                [dataField]="filterModelName('number')"
                editorType="dxTextBox"
                [editorOptions]="{placeholder: 'Number',stylingMode: 'filled'}"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="'employee.name'"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Employee', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('typeOfChange')"
                editorType="dxSelectBox"
                [editorOptions]="{
                    placeholder: 'Type',
                    stylingMode: 'filled',
                    items: typeOptions,
                    valueExpr: 'value',
                    displayExpr: 'text'
                }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('status')"
                editorType="dxSelectBox"
                [editorOptions]="{
                    placeholder: 'Status',
                    stylingMode: 'filled',
                    items: statusOptions,
                    valueExpr: 'value',
                    displayExpr: 'text'
                }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('submittedDate')"
                editorType="dxDateBox"
                [editorOptions]="{ placeholder: 'Submitted Date', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
        </dx-form>
    </filter-panel>
    <app-change-request-popup [(visible)]="isPopupOpened" (onAdd)="onAdd()" (onStatusChange)="onStatusChange($event)"
                       [request]="selectedRow"></app-change-request-popup>
</div>
